import { render } from "./UpdateExistingTable.vue?vue&type=template&id=906387ea&scoped=true"
import script from "./UpdateExistingTable.vue?vue&type=script&lang=js"
export * from "./UpdateExistingTable.vue?vue&type=script&lang=js"

import "./UpdateExistingTable.vue?vue&type=style&index=0&id=906387ea&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906387ea"]])

export default __exports__